var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{class:[
    'v-icon',
    ("v-icon--size-" + _vm.size),
    _vm.sizeMd && ("v-icon--size-md-" + _vm.sizeMd),
    _vm.sizeLg && ("v-icon--size-lg-" + _vm.sizeLg)
  ],attrs:{"src":_vm.src}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }